"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propInserter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const propInserter = (BaseComponent, { ssrProps }) => 
// eslint-disable-next-line react/display-name
props => (0, jsx_runtime_1.jsx)(BaseComponent, Object.assign({}, ssrProps, props));
exports.propInserter = propInserter;
//# sourceMappingURL=propsInserter.js.map